import { darken, lighten } from 'polished';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import signInBackgroundImg from '../../assets/sign-in-background.png';
import { COLORS } from '../../styles/constants';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: stretch;
  background: ${COLORS.background};
`;

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-50px);
  }
  to{
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100vh;
  max-width: 700px;
`;

export const AnimationContainer = styled.div`
  min-height: 130px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  animation: ${appearFromLeft} 1s;

  img {
    width: 150px;
  }

  h1 {
    font-size: 60px;
    margin-bottom: 24px;
  }

  p {
    color: ${darken(0.6, COLORS.primary)};
  }
`;

export const SignInOptionButton = styled.button`
  width: 270px;
  padding: 14px;
  border: none;
  border-radius: 5px;
  margin-bottom: 20px;

  transition: box-shadow 0.2s;

  color: #fff;
  background: ${COLORS.primary};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.19);

  display: flex;
  align-items: center;

  img {
    margin: 5px;
    width: 40px;
    margin-right: 25px;
  }

  &:hover {
    background: ${lighten(0.02, COLORS.primary)};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 2px 4px 0 rgba(0, 0, 0, 0);
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${signInBackgroundImg}) no-repeat center;
  background-size: cover;
`;

export const ReturnLink = styled(Link)`
  width: 90%;
  margin-top: 10px;

  text-decoration: none;

  display: flex;
  justify-content: space-between;

  &:hover {
    color: ${COLORS.primary};
    font-weight: 600;
  }
`;
